import React from "react";
import { Heading, Flex, Text, Box, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { generatePath } from "react-router";

import Frames from "modules/preview/components/Frames";
import { Link as RouterLink } from "react-router-dom";
import TestForm from "modules/test/components/TestForm";
import { RouteIdParam } from "modules/shared/schemas/paramsSchema";
import ArrowBackIcon from "core/components/InterfaceIcons/ArrowBackIcon";
import ScreenContainer from "modules/shared/components/ScreenContainer/ScreenContainer";
import useIsArchivedTemplate from "modules/preview/hooks/useIsArchivedTemplate";
import ErrorMessage from "modules/shared/components/ErrorHandler/ErrorMessage";
import { PATHS } from "modules/shared/constants/paths";

const Test = () => {
  const { t } = useTranslation();
  const { id } = useParams<RouteIdParam>();
  const isArchived = useIsArchivedTemplate();

  return isArchived ? (
    <ErrorMessage messageText={t("errors.archived")} />
  ) : (
    <ScreenContainer>
      <Heading as="h1" size="lg" mb={10} mt={10}>
        {t("actions.test.title")}
      </Heading>
      <Flex>
        <Box>
          <Flex justifyContent="space-between" mb="5px">
            <Text fontSize="xs"> {t("actions.test.subtitle")}</Text>
            <Button
              leftIcon={<ArrowBackIcon mr="5px" />}
              variant="link-button"
              as={RouterLink}
              to={generatePath(PATHS.TEMPLATE, {
                id: id!,
              })}
            >
              {t("actions.test.back")}
            </Button>
          </Flex>
          <Frames />
        </Box>
        <TestForm />
      </Flex>
    </ScreenContainer>
  );
};

export default Test;
